import L from 'leaflet';

export default L.icon({
  iconSize: [25, 25],
  iconAnchor: [10, 41],
  popupAnchor: [2, -40],
  iconUrl: 'https://static.thenounproject.com/png/1450280-200.png'
});